import React from "react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import { Link, useLocation, useNavigate } from "react-router";

import LoginForm from "./LoginForm";
import useAuthActions from "../hooks/useAuthActions";
import { signInWithGoogle } from "../api/firebase";
import { signInWithApple } from "../api/firebase";

import appStoreBadge from "../assets/app_store_download.svg";
import googlePlayBadge from "../assets/google-play-badge-cropped.png";

const LoginPage = () => {
  const { attemptLogin } = useAuthActions();
  const location = useLocation();
  const navigate = useNavigate();

  const onSubmit = (formValues: any) => {
    attemptLogin(formValues);
  };

  return (
    <div>
      <div className="max-w-2xl mx-auto px-4">
        <h1 className="text-3xl font-bold my-4">KilnHelper</h1>
        {location?.state?.from?.pathname === "/user_delete" && (
          <p className="text-red-600">
            In order to delete your user, you must first log in. Once Logged in, click on your
            profile icon on the top right, and select 'Preferences'. In there you will find a link
            to the user deletion page.
          </p>
        )}
        <LoginForm onSubmit={onSubmit} />
        <Link
          to="/reset-password"
          className="text-sm text-primary hover:underline mb-4 inline-block"
        >
          Forgotten your password?
        </Link>
        <div className="flex gap-2 mb-4">
          <Button variant="outline" onClick={() => signInWithGoogle(navigate)}>
            Sign In With Google
          </Button>
          <Button variant="outline" onClick={() => signInWithApple(navigate)}>
            Sign In With Apple
          </Button>
        </div>
        <h3 className="text-lg font-semibold mt-6 mb-2">
          New to KilnHelper? Download the KilnHelper app on the Apple App Store or Google Play Store
          to create an account.
        </h3>
        <div className="flex items-center gap-2">
          <a href="https://apps.apple.com/gb/app/kiln-helper/id1506041444">
            <img
              src={appStoreBadge}
              alt="Download on the App Store"
              className="h-[50px] w-auto"
            />
          </a>
          <a href="https://play.google.com/store/apps/details?id=uk.co.muttleycru.kilnhelper">
            <img
              src={googlePlayBadge}
              alt="Get it on Google Play"
              className="h-[50px] w-auto"
            />
          </a>
        </div>
        <Separator className="my-4" />
      </div>
    </div>
  );
};

export default LoginPage;
